// extracted by mini-css-extract-plugin
module.exports = {"shopifyWelcomeWrapper":"ShopifyWelcome_shopifyWelcomeWrapper__1wT4Z"};